{
  "light": {
    "land": "#E8E8E6",
    "water": "#D5D9DC",
    "park": "#DCE3D6",
    "building": "#DADAD7",
    "buildingEdge": "#CFCFCC",
    "road": "#FFFFFF",
    "roadMinor": "#F4F4F2",
    "roadCasing": "#D2D2CF",
    "rail": "#B9B9B6",
    "path": "#CFCFCB",
    "label": "#3C3C3C",
    "labelHalo": "#FAFAFA",
    "days": [
      "#2F5BEA",
      "#C0187A",
      "#0B7A6E",
      "#C2410C",
      "#7C3AED",
      "#C81E3A",
      "#56730F",
      "#475467"
    ],
    "surface": "#FAFAFA",
    "ink": "#191919",
    "signal": "#FFFA00"
  },
  "dark": {
    "land": "#1E1F22",
    "water": "#121417",
    "park": "#1F2620",
    "building": "#26272B",
    "buildingEdge": "#2A2B2F",
    "road": "#34363B",
    "roadMinor": "#2B2D31",
    "roadCasing": "#2A2B2F",
    "rail": "#3A3C41",
    "path": "#2E3034",
    "label": "#A3A3A6",
    "labelHalo": "#131315",
    "days": [
      "#6B8CFF",
      "#FF5CB8",
      "#2DD4BF",
      "#FB8C3C",
      "#A78BFA",
      "#FF6B81",
      "#A3C94A",
      "#98A2B3"
    ],
    "surface": "#131315",
    "ink": "#F2F2F2",
    "signal": "#FFFA00"
  },
  "lightHighContrast": {
    "land": "#E8E8E6",
    "water": "#D5D9DC",
    "park": "#DCE3D6",
    "building": "#DADAD7",
    "buildingEdge": "#CFCFCC",
    "road": "#FFFFFF",
    "roadMinor": "#F4F4F2",
    "roadCasing": "#D2D2CF",
    "rail": "#B9B9B6",
    "path": "#CFCFCB",
    "label": "#191919",
    "labelHalo": "#FFFFFF",
    "days": [
      "#2F5BEA",
      "#C0187A",
      "#0B7A6E",
      "#C2410C",
      "#7C3AED",
      "#C81E3A",
      "#56730F",
      "#475467"
    ],
    "surface": "#FAFAFA",
    "ink": "#191919",
    "signal": "#FFFA00"
  },
  "darkHighContrast": {
    "land": "#1E1F22",
    "water": "#121417",
    "park": "#1F2620",
    "building": "#26272B",
    "buildingEdge": "#2A2B2F",
    "road": "#34363B",
    "roadMinor": "#2B2D31",
    "roadCasing": "#2A2B2F",
    "rail": "#3A3C41",
    "path": "#2E3034",
    "label": "#F2F2F2",
    "labelHalo": "#0E0E10",
    "days": [
      "#6B8CFF",
      "#FF5CB8",
      "#2DD4BF",
      "#FB8C3C",
      "#A78BFA",
      "#FF6B81",
      "#A3C94A",
      "#98A2B3"
    ],
    "surface": "#131315",
    "ink": "#F2F2F2",
    "signal": "#FFFA00"
  }
}
